import { render, staticRenderFns } from "./card_consulta.vue?vue&type=template&id=0151f708&"
import script from "./card_consulta.vue?vue&type=script&lang=js&"
export * from "./card_consulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports